/* istanbul ignore file */
import React from 'react';
import { usePurchaseOrderUrl } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';
import { LinkButton } from 'framework/ui/ui-builder';

const ViewPurchaseOrderButton = (props: any) => {
  const { getSingleEntityUrl } = usePurchaseOrderUrl();

  return (
    <LinkButton url={getSingleEntityUrl} key="view-purchase-order" outline {...props}>
      View
    </LinkButton>
  );
};

export default ViewPurchaseOrderButton;
